import { CircularProgress } from "@material-ui/core";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import { resetWelcomeNotificationSession } from "../sustell_15/utils/notificationFilters";

export const SignOut = async () => {
  const history = useHistory();

  resetWelcomeNotificationSession();
  await Auth.signOut();
  history.push("/");
  window.location.reload();

  return (
    <div style={{ justifyContent: "center" }}>
      <CircularProgress />
    </div>
  );
};
